import { createContext, useContext } from 'react'
import type { SideNavigationMenuGroup } from '@/ui/components/Header/SideNavigation/types/SideNavigationTypes'

interface SideNavContextType {
    menuGroups: SideNavigationMenuGroup[] | null
    setMenuGroups: (groups: SideNavigationMenuGroup[] | null) => void
}

export const SideNavContext = createContext<SideNavContextType>({
    menuGroups: null,
    setMenuGroups: () => {},
})

export const useSideNavMenu = () => useContext(SideNavContext)
